import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const [showProxyOptions, setShowProxyOptions] = useState(false);
  const { connectionString } = formData;
  const handleShowProxyChange = (event, fieldData) => {
    const enableProxy = event.target.checked;
    setShowProxyOptions(enableProxy);
    if (!enableProxy) {
      formData.proxyOptions.value = "";
    }
    onChange(event, fieldData);
  };
  const handleSubmit = () => {
    var _a, _b, _c, _d, _e;
    const fetcher = fetch("POST", qualifyUrl(ApiRoutes.INTEGRATIONS.Azure.CHECK_CREDENTIALS), {
      azure_event_hub_name: ((_a = formData == null ? void 0 : formData.eventHubName) == null ? void 0 : _a.value) || "",
      azure_connection_string: ((_b = formData == null ? void 0 : formData.connectionString) == null ? void 0 : _b.value) || "",
      azure_consumer_group: ((_c = formData == null ? void 0 : formData.consumerGroup) == null ? void 0 : _c.value) || "",
      azure_enable_proxy: ((_d = formData == null ? void 0 : formData.enableProxy) == null ? void 0 : _d.value) || false,
      azure_proxy_options: ((_e = formData == null ? void 0 : formData.proxyOptions) == null ? void 0 : _e.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: "Unable to connect to Azure using provided configuration."
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: "Unable to connect to Azure using provided configuration."
      });
    });
  };
  const proxyIsValid = () => {
    var _a, _b;
    const missingProxyOptions = ((_a = formData == null ? void 0 : formData.proxyOptions) == null ? void 0 : _a.value) === "";
    const proxyEnabled = !!((_b = formData == null ? void 0 : formData.enableProxy) == null ? void 0 : _b.value) || false;
    return !(proxyEnabled && missingProxyOptions) || false;
  };
  const isFormValid = () => {
    const formValid = !formValidation.isFormValid(
      ["azureName", "eventHubName", "connectionString", "consumerGroup"],
      formData
    );
    return formValid && proxyIsValid();
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: !isFormValid(),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "azureName",
        type: "text",
        fieldData: formData.azureName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "eventHubName",
        type: "text",
        fieldData: formData.eventHubName,
        onChange,
        label: "Event Hub Name",
        help: "The name of the Event Hub.",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "connectionString",
        type: "password",
        onChange,
        fieldData: formData.connectionString,
        help: "The connection string required to communicate with Event Hub.",
        label: "Connection String",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "consumerGroup",
        type: "text",
        onChange,
        fieldData: formData.consumerGroup,
        label: "Consumer Group",
        help: "The consumer group name in the Event Hub.",
        placeholder: "$Default",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "checkbox",
        className: "",
        id: "enableProxy",
        onChange: handleShowProxyChange,
        fieldData: formData.enableProxy,
        label: "Enable Proxy"
      }
    ),
    showProxyOptions && /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "proxyOptions",
        type: "text",
        onChange,
        fieldData: formData.proxyOptions,
        label: "Proxy URI",
        placeholder: "https://<proxy-host>:5672",
        help: "The HTTPS forward proxy URI. If specified, the connection to Azure will be made over port 443 (HTTPS) using the AMQP over WebSockets protocols."
      }
    )
  );
};
export default StepAuthorize;
